import { render, staticRenderFns } from "./WorkShift.vue?vue&type=template&id=39cb07f9&scoped=true"
import script from "./WorkShift.vue?vue&type=script&lang=js"
export * from "./WorkShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cb07f9",
  null
  
)

export default component.exports